export enum OAuth2KakaoPrompt {
    None = 'none',
    Login = 'login',
    Create = 'create',
    SelectAccount = 'select_account',
}
